exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.product-listing .product {\n  position: relative;\n}\n", ""]);

// exports
